export default __webpack_public_path__ + "static/media/bottlespray-thumb.dcb5f1d2.png";